<script setup lang="ts">
  import { cn } from "@/lib/utils"
  import {
    ComboboxGroup,
    ComboboxLabel,
    type ComboboxGroupProps,
  } from "reka-ui"
  import { computed, type HTMLAttributes } from "vue"

  const props = defineProps<
    ComboboxGroupProps & {
      class?: HTMLAttributes["class"]
      heading?: string
    }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })
</script>

<template>
  <ComboboxGroup
    v-bind="delegatedProps"
    :class="
      cn(
        'w-max text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground',
        props.class,
      )
    "
  >
    <ComboboxLabel
      v-if="heading"
      class="px-2 py-1.5 text-xs font-medium text-muted-foreground"
    >
      {{ heading }}
    </ComboboxLabel>
    <slot />
  </ComboboxGroup>
</template>
